import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Input } from '@/components/ui/input';

export interface SearchFieldOption {
  label: string;
  key: string;
  match: 'fuzzy' | 'filter';
}

interface FieldSearchProps {
  fields: SearchFieldOption[];
  field: string;
  onFieldChange: (field: string) => void;
  keyword: string;
  onKeywordChange: (keyword: string) => void;
  className?: string;
}

// eslint-disable-next-line react-refresh/only-export-components
export function buildSearchParams(
  field: string,
  keyword: string,
  fields: SearchFieldOption[]
): { fuzzy: Record<string, string>; filter: Record<string, string> } {
  const trimmed = keyword.trim();
  if (!trimmed) return { fuzzy: {}, filter: {} };
  const option = fields.find((f) => f.key === field);
  if (!option) return { fuzzy: {}, filter: {} };
  if (option.match === 'fuzzy') return { fuzzy: { [field]: trimmed }, filter: {} };
  return { fuzzy: {}, filter: { [field]: trimmed } };
}

export function FieldSearch({
  fields,
  field,
  onFieldChange,
  keyword,
  onKeywordChange,
  className,
}: FieldSearchProps) {
  const currentOption = fields.find((f) => f.key === field) ?? fields[0];

  return (
    <div className={`flex items-center gap-2 ${className ?? ''}`}>
      <Select value={field} onValueChange={onFieldChange}>
        <SelectTrigger className="h-9 w-[120px] shrink-0 text-sm">
          <SelectValue>{currentOption?.label}</SelectValue>
        </SelectTrigger>
        <SelectContent>
          {fields.map((f) => (
            <SelectItem key={f.key} value={f.key}>
              {f.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Input
        placeholder={`按${currentOption?.label ?? '名称'}搜索...`}
        value={keyword}
        onChange={(e) => onKeywordChange(e.target.value)}
        className="w-52"
      />
    </div>
  );
}
